angular.module('cerberus.les')
    .controller('LESQuickApplicationFindingsCtrl', function (_, kendo, moment, $scope, $document, $location, $timeout, $uibModalInstance,
                                                              loanApplicationId, productId, product, pricingIndex,
                                                              lesLoanApplicationsService, normalPrintingService) {
        var vm = this;
        var today = new Date();

        vm.loanApplicationId = loanApplicationId;
        vm.simpleLoanId = _.last(loanApplicationId.split('-'));
        vm.productId = productId;
        vm.product = product;
        vm.pricing = product.pricing[pricingIndex];
        vm.primaryBorrowerName = '';
        vm.propertyAddress = '';
        vm.applicationDataLoaded = false;
        vm.reasons = [];
        vm.reasonCategories = {};
        vm.incomeSources = [];
        vm.proposedExpenses = [];
        vm.printingFindingsReport = false;
        vm.showReasonsCitations = false;
        vm.eligibilityRunDate = '';
        vm.totalOtherProposedExpenses = 0;
        vm.totalRateAdjustments = 0;
        
        vm.ok = ok;
        vm.cancel = cancel;
        vm.formatPercentage = formatPercentage;
        vm.formatDate = formatDate;
        vm.min = min;
        vm.finalRate = finalRate;
        vm.totalAssets = totalAssets;
        vm.setReasons = setReasons;
        vm.printFindingsReport = printFindingsReport;
        vm.assetSum = assetSum;
        vm.totalIncome = totalIncome;

        init();

        function init() {
            vm.totalRateAdjustments = 0;

            _.forEach(product.adjustments, function(adj){
                vm.totalRateAdjustments += adj.value;
            });
            
            setReasons();

            lesLoanApplicationsService.getLoanApplication(loanApplicationId).then(function (loanApplication) {
                if(loanApplication.recordData.findings){
                    vm.loanApplication = loanApplication.recordData.loanApp;
                }
                else{
                    vm.loanApplication = loanApplication.recordData;
                }

                var mainBorrowerName = _.get(vm.loanApplication, 'mainBorrower.fullName');
            
                vm.primaryBorrowerName = mainBorrowerName || 'No Primary Borrower';
                vm.applicationDataLoaded = true;

                if (vm.loanApplication.RegisteredDate) {
                    vm.eligibilityRunDate = vm.loanApplication.RegisteredDate;
                }
                else {
                    vm.eligibilityRunDate = today;
                }

                if (_.has(vm.loanApplication, 'PropertyAddress.properties.formatted_address')) {
                    vm.propertyAddress = vm.loanApplication.PropertyAddress.properties.formatted_address;
                }
                else {
                    vm.propertyAddress = vm.loanApplication.PropertyAddressStreetAddress + ' ' + vm.loanApplication.PropertyAddressCity + ' ' + vm.loanApplication.PropertyAddressState + ' ' + vm.loanApplication.PropertyAddressZIPCode;
                }
            });
        }

        function ok() {
            $uibModalInstance.close(vm.pricing);
        }

        function cancel(){
            $uibModalInstance.dismiss('cancel');
        }

        function formatPercentage(number, decimals) {
            decimals = decimals || '';
            return kendo.toString(number, 'p' + decimals);
        }

        function formatDate(dateValue, format) {
            if (!dateValue) {
                return '';
            }
            if (_.isString(dateValue)) {
                dateValue = moment(dateValue, ['MMMM, DD YYYY HH:mm:ss', 'YYYY-MM-DDTHH:mm:ssZ']).toDate();
            }
            return kendo.toString(dateValue, format);
        }

        function setReasons() {
            var reasons = [];

            if(!_.isEmpty(vm.product)){
                reasons = reasons.concat(vm.product.reasons);
            }
            if(!_.isEmpty(vm.pricing)){
                reasons = reasons.concat(vm.pricing.reason);
            }

            /* LODASH Version 4 ONLY */
            //var standardReasons = _.reject(reasons, 'type', 'Rate Sheet');
            /* LODASH Version 3 & 4 Compatibility Mode */
            var standardReasons = _.reject(reasons, function(r){return r.type === 'Rate Sheet';});
            if (standardReasons.length) {
                reasons = standardReasons;
            }

            vm.reasons = reasons;
            vm.reasonCategories = formatReasons(reasons);
        }

        function formatReasons(reasons) {
            var result = {};

            _.forEach(reasons, function (r) {
                if (r.type) {
                    var category = r.type.toLowerCase();
                    if (!result[category]) {
                        result[category] = { label: r.type, eligibility: r.eligibility };
                    }
                    else if (result[category].eligibility != 'ineligible') {
                        result[category].eligibility = r.eligibility;
                    }
                }    
            });

            return result;
        }

        function min(a, b) {
            return Math.min(a, b);
        }

        function finalRate(baseRate, adjustments) {
            var final = baseRate;

            _.forEach(adjustments, function (adj) {
                final += adj.value;
            });

            return final;
        }

        function totalAssets(assetMap) {
            return assetMap.closingCosts.total + assetMap.downPayment.total + assetMap.reserves.total;
        }

        function assetSum(assets, key) {
            return assets.downPayment[key] + assets.prepaid[key] + assets.buyDown[key]  + assets.fundingFee[key] + assets.closingCosts[key];
        }

        function totalIncome(incomeSources, type) {
            if (type) {
                /* LODASH Version 4 ONLY */
                //incomeSources = _.filter(incomeSources, ['BorrowerCurrentIncome_IncomeType_display', type]);
                /* LODASH Version 3 & 4 Compatibility Mode */
                incomeSources = _.filter(incomeSources, function(c){return c.BorrowerCurrentIncome_IncomeType_display === type;});
            }

            var total = 0;

            _.forEach(incomeSources, function(income) {
                total += income.BorrowerCurrentIncome_MonthlyTotalAmount;
            });

            return total;
        }

        function printFindingsReport() {
            if (!vm.printingFindingsReport){
                vm.printingFindingsReport = true;

                $timeout(function () {
                    var findingsReportElement = $document.find('#findings-report'),
                        filename = kendo.format('Findings Report - {0:u}', new Date()),
                        options = {
                            paperSize: 'letter',
                            landscape: false,
                            margin: 0
                        };
                    
                    normalPrintingService.printElement(findingsReportElement, filename, options).then(function () {
                        $timeout(function () {
                            vm.printingFindingsReport = false;
                        });
                    });
                });
            }
        }

        // Prevents navigation while modal is open
        $scope.$on('$locationChangeStart', function(event){
            event.preventDefault();
        });
    })
;